export default __webpack_public_path__ + "static/media/lp_1.2912e41e.jpg";